function deferFilterjQuery() {
    if (window.jQuery) {
        var $ = window.jQuery;
        $(function(){
          // On load/reload
          var pt_on_load = function() {
            // Accordion
            

            // Search
            $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

            // Drop downs
            $('.pt-display-dropdown').each(function( index ) {
                $(this).find('h4').after($(this).find('.filter-clear'));
            });

            $('.pt-display-dropdown .scroll-content').each(function( index ) {
                if($(this).parent().find('.menu-trigger').length === 0) {
                    if($(this).find('li.selected').length) {
                        var selected = $.map(
                            $(this).find('li.selected a'),
                                function(element){
                                    return $(element).text();
                                }
                        ).join(", ");

                        if (selected.length < 30) {
                            $(this).before('<div class="menu-trigger">' + selected +'</div>');
                        } else {
                            $(this).before('<div class="menu-trigger">' + $(this).find('li.selected').length + ' Selected </div>');
                        }
                    }
                    else {
                        $(this).before('<div class="menu-trigger">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
                    }
                }
            });

            //Sticky Mode
            

            // View more
            

            $('.filter-menu li a').attr('title', function() {
              return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();
            });

            // Handle nested filters
            var splitPath = function(url) {
              var splitUrl =  url.split('?')[0].split('#')[0].split('/');
              return splitUrl;
            }

            var getCollection = function(url) {
              var splitUrl = splitPath(url);
              return splitUrl[2];
            }

            var getTags = function(url) {
              var splitUrl = splitPath(url);
              return (splitUrl[3] || '').split('+');
            }

            var getCommonCollection = function(url_top, url_nested) {
              var collection_top = getCollection(url_top);
              var collection_nested = getCollection(url_nested);
              if (collection_top !== collection_nested) {
                return 'all';
              }
              return collection_top;
            }

            var getCommonTags = function(url_top, url_nested) {
              var tags_top = getTags(url_top);
              var tags_nested = getTags(url_nested);

              return tags_top.filter(function(n) {
                return tags_nested.indexOf(n) > -1;
              });
            }

            var getCommonUrl = function(url_top, url_nested) {
              var val = '/collections/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');

              var lastChar = val.slice(-1);
                    if (lastChar == '/') {
                    val = val.slice(0, -1);
                }

              return val;
            }

            var clearNestedParent = $('.pt-display-nested').prev().each(function() {
              var clearNested = $(this).next().find('a.filter-clear').attr('href');
              if (!clearNested) return;
              var clearLink = $(this).find('a.filter-clear');
              clearLink.attr('href', getCommonUrl(clearLink.attr('href'), clearNested))
              var filterLinks = $(this).find('li.selected .collection-name a').each(function() {
                $(this).attr('href', getCommonUrl($(this).attr('href'), clearNested))
              })
            })
            
            // custom tooltips
            var headers = Array.from('Disciplines#Model#Diameter#Width#Contact Patch#Lip/Edge Style#Surface Style#Bearing Seat#Formula#Durometer#Weight (per Wheel)'.split('#'));
            var tooltips = Array.from('Select how you prefer to skate#Select how your favorite wheel#Wheel height. Smaller wheels accelerate quicker. Taller wheels roll more easily over rough, uneven surfaces and have a higher top speed.#Width measured at the widest part of the wheel.#Width of the portion of the wheel in contact with the ground. Wider contact patches offer greater traction. Narrower contact patches slide more easily.#Sharp lips offer maximum traction and are ideal for carving, pumping, downhill, and slalom riding. Rounded lips slide more smoothly and are ideal for freeride and freestyle. Rounded lips also help wheels pass more smoothly across pavement cracks when commuting.#Stone-ground wheels slide more easily even when brand new. Wheels with surface skin retain maximum traction.#Position of the wheel core where bearings are installed. Centerset wheels can be “flipped” (mounted in either orientation) to promote more even wear over time and tend to narrow the board’s footprint. Offset wheels allow more freedom for the outer lip to deform and grip the road and tend to widen the board’s footprint.#The urethane formula used to pour the wheel. Orangatang offers four proprietary wheel formulas: Happy Thane (smooth, fast, high traction, buttery slides), Peachy Thane (balanced traction, high durability), Euphorethane (long slides, exceptional durability), and Perky Thane (smooth and durable for park and pool skating).#Measure of wheel hardness. Softer wheels (77a-80a and lower) offer more traction and roll smoother and faster over rough surfaces. Harder wheels (83a-86a and higher) slide more easily, offer greater durability, and roll faster over smooth surfaces.#How much each wheel weighs.'.split('#'));

            for(var i = 0; i < headers.length; i++) {
              var icon = document.createElement('img');
              icon.setAttribute('class', 'pt-tooltip-icon');
              icon.setAttribute('src', '//www.orangatangwheels.com/cdn/shop/t/30/assets/info-icon.png?v=92597928939222375281781123682');
              var tipTitle = document.createElement('span');
              tipTitle.setAttribute('style', 'font-weight:bold;');
              tipTitle.innerText = headers[i] + ': ';
              var text = document.createElement('span');
              text.setAttribute('class', 'pt-tooltip-text');
              text.innerText = tooltips[i];
              text.insertBefore(tipTitle, text.firstChild);
              $('.filter-group h4:contains(' + headers[i] + ')').append(icon, text);
            }
          }

          pt_on_load();

          // Mobile filter button
          
          $(document).on('click', '.filter-menu .pt-mobile-header a', function(e){
            if(e.handled !== true) {
              if ($('.pt-nav-toggle').hasClass('active')) {
                $('.filter-menu').removeClass('pt-expand');
                $('.pt-display-dropdown .scroll-content').hide();
              } else {
                $('.filter-menu').addClass('pt-expand');
              }

              $('.pt-nav-toggle').toggleClass('active');
              e.preventDefault();
              e.handled = true;
            }
          });

          

          // Accordion
          

          // Search
          $(document).on('keyup', '.filter-group input.fm-search-box', function () {
            var value = this.value.toLowerCase();
            $(this).closest('.filter-group').find('li').each(function () {
              if ($(this).text().toLowerCase().search(value) > -1) {
                $(this).show(100);
              } else {
                $(this).hide(100);
              }
            });
          });

          // Drop downs
          $(document).on('click','.pt-display-dropdown .menu-trigger',function() {
            $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
            $(this).next('.scroll-content').slideToggle('fast');
          });

          $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
            $(this).slideUp('fast');
          });

          // Apply button
          

          // Ajax
          
          $.getScript("//www.orangatangwheels.com/cdn/shop/t/30/assets/jquery.pjax.js?v=138580039773092267901781123682").done(function(script, textStatus) {
            $body = $("body");
            $(document).pjax('#main .filter-group a, #main .pagination a', '#main', { fragment: '#main', timeout: 10000, scrollTo: false, push: true });
            $(document).on('pjax:start', function(){  $body.addClass("pt-ajax-loading"); $('#main').fadeTo('slow', 0.8); })
            $(document).on('pjax:end', function(){ $body.removeClass("pt-ajax-loading"); $('#main').fadeTo('fast', 1); pt_on_load(); ; });
          });
          
      });
    }
    else {
        setTimeout(function() { deferFilterjQuery() }, 50);
    }
}

deferFilterjQuery();
